import { defineMessages } from 'react-intl';

export const messages: {
	addSubItemButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	editPropertiesButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	itemCreationDisabledTooltipText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveItemDownText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveItemUpText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	openLinkButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	openLinkButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text',
		defaultMessage: 'Open the link',
		description: 'Text for the open link button in the item dropdown',
	},
	editPropertiesButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text',
		defaultMessage: 'Edit properties',
		description: 'Text for the edit properties button in the item dropdown',
	},
	addSubItemButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text',
		defaultMessage: 'Add sub item',
		description: 'Text for the add sub item button in the item dropdown',
	},
	moveItemUpText: {
		id: 'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text',
		defaultMessage: 'Move up',
		description: 'Text for the move item up button in the item dropdown',
	},
	moveItemDownText: {
		id: 'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text',
		defaultMessage: 'Move down',
		description: 'Text for the move item down button in the item dropdown',
	},
	itemCreationDisabledTooltipText: {
		id: 'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text',
		defaultMessage:
			'You have reached the maximum number of items that can be added to a links menu.',
		description:
			'Text on a tooltip over a disabled button that would normally allow user to create new items, explaining that they have hit the limit for item creation',
	},
});
